import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const formService = {
  add_new: (customer_id, form_id, formData, serviceId, token) => {
    return https.post(
      `${API_ROUTES.FORM.ADD_NEW}/${customer_id}/${form_id}/${serviceId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  update: (form_id, formData, token) => {
    return https.put(
      `${API_ROUTES.PROFILE.UPDATE}/${form_id}/details`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
};
